
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import FormButton from '../ui/button/FormButton';
import {useDispatch, useSelector} from 'react-redux';
import {API} from '../../pages/backend';
import axios from 'axios';
import {Box, Typography} from '@mui/material';
import {toast} from 'react-toastify';
import {MdErrorOutline} from 'react-icons/md';
import {TbFaceIdError} from 'react-icons/tb';
import {showModal} from '../../store/reducers/modal';
import domtoimage from 'dom-to-image';
import ResponsiveFormButton from '../ui/button/ResponsiveFormButton';
import styles from './billcard.module.scss';
import Spinner from '../ui/Spinner';
import {Link, useNavigate} from 'react-router-dom';
import Invoicedownload from '../invoice/Invoicedownload';
import {setTransactionDetails} from '../../store/reducers/transactionDetails';
import {setBills} from '../../store/reducers/bills';
import {PDFDownloadLink} from '@react-pdf/renderer';
import DownloadToPdf from '../downloadReceipt/DownloadToPdf';
import Swal from 'sweetalert2';

const SchoolBaseBillCard = ({url, examName}) => {
  console.log(url);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const details = useSelector(
    (state) => state?.transactionDetails?.data?.transactionDetails
  );
  const schoolDetails = useSelector((state) => state.user.data.details);
  // const details = useSelector((state) => state.transactionDetails.data.transactionDetails)
  // console.log(details);
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingState, setLoadingState] = useState({});
  const user = useSelector((state) => state.user.data.details);
  const token = useSelector((state) => state?.user?.data?.token);
  // console.log(token);
  const [billDetails, setBillDetails] = useState([]);
  console.log(billDetails);

  const [getPinDetails, setPinDetails] = useState();

  const getAllBills = async () => {
    try {
      const res = await axios.get(url, {
        headers: {Authorization: `Bearer ${token}`},
      });
      if (res?.status === 200) {
        // console.log(res?.data?.details?.rows);
        // console.log(res?.data?.data?.details?.rows);
        setBillDetails(res?.data?.data?.details?.rows);
        const bills = res?.data?.data?.details?.rows;
        console.log(bills);
        dispatch(setBills(bills));
      }
    } catch (error) {
      toast.error('Cannot generate bill cards at the moment. Try again later.');
      // console.log(error);
    }
  };

  const formatDate = (dateArg) => {
    let time = 'loading...';
    let date = 'loading...';
    if (dateArg) {
      time = new Date(dateArg).toLocaleTimeString('en-GB', {hour12: true});
      date = new Date(dateArg).toDateString();
    }

    let datetime = time + ' ' + date;
    return {time, date, datetime};
  };



  // links
  const link = examName ? "Screening" : ""

  // const generatePin = async (billNumber) => {
  //   // Find the specific bill with the matching payerId
  //   setLoadingState((prev) => ({...prev, [billNumber]: true}));
  //   const bill = billDetails.find((bill) => bill.billNumber === billNumber);

  //   const payersDetails = {
  //     billNumber: bill.billNumber,
  //     payerId: bill.payerId,
  //     assessmentCode: bill.assessmentCode,
  //     payerInfos: bill.payerInfos,
  //     schoolId:schoolDetails.schoolId,
  //     totalPaidFor:bill.quantity
  //     // payerInfos: [ {
  //     //   "surname" : "doe",
  //     //   "firstName": "jane",
  //     //   "locationIdOrExamId":"0006"
  //     //   }
  //     // ]
  //   };

  //   console.log(payersDetails);

  //   try {
  //     // setLoading(true)
  //     const res = await axios.post(
  //       `${API}/innotelligent/generate/school_code/${schoolDetails?.id}`,
  //       payersDetails,
  //       {
  //         headers: {Authorization: `Bearer ${token}`},
  //       }
  //     );

  //     console.log(res);
  //     if (res?.status === 200 || res?.status === 200) {
  //       // console.log(res?.status)
  //       // const { fullName, examinationNumber, pin } = res.data.data.candidateLoginDetails[0];
  //       const candidateDetails = res.data.data.message;

  //       // Generate candidate details content
  //       const candidateContent = candidateDetails.map((candidate, index) => (
  //         <div key={index} style={{width: '100%'}}>
  //           <div
  //             style={{
  //               display: 'flex',
  //               height: 'auto',
  //               gap: window.innerWidth >= 500 ? '90px' : '40px',
  //             }}>
  //             <Typography>{candidate.fullName}</Typography>
  //             <Typography>{candidate.examinationNumber}</Typography>
  //             <Typography>{candidate.pin}</Typography>
  //           </div>
  //         </div>
  //       ));
  //       console.log(candidateDetails);
  //       console.log(payersDetails);
  //       setPinDetails(payersDetails);

  //       dispatch(
  //         showModal({
  //           content: (
  //             <div>
  //               <div>
  //                 <div
  //                   id='modalContent'
  //                   style={{
  //                     backgroundColor: 'white',
  //                     display: 'flex',
  //                     flexDirection: 'column',
  //                     alignItems: 'center',
  //                     height: '550px',
  //                     maxHeight: '400px',
  //                     overflowY: 'auto',
  //                     overflowX: 'auto',
  //                     position: 'relative',
  //                   }}>
  //                   <Typography fontWeight={'bold'} variant='h6'>
  //                     Receipt generated successfully
  //                   </Typography>
  //                   {/* the background image */}
  //                   <div className={styles.receipt_image}></div>
  //                   <div
  //                     style={{
  //                       display: 'flex',
  //                       gap: window.innerWidth >= 500 ? '90px' : '40px',
  //                       marginTop: '20px',
  //                     }}>
  //                     <Typography fontWeight={'bold'}>Full Name:</Typography>
  //                     <Typography fontWeight={'bold'}>
  //                       Examination Number:
  //                     </Typography>
  //                     <Typography fontWeight={'bold'}>Pin:</Typography>
  //                   </div>
  //                   <div style={{gap: '10px'}}>{candidateContent}</div>
  //                 </div>
  //               </div>
  //               <div
  //                 style={{
  //                   display: 'flex',
  //                   flexWrap: 'wrap',
  //                   alignItems: 'center',
  //                   justifyContent: 'center',
  //                   margin: 'auto',
  //                   gap: window.innerWidth >= 500 ? '100px' : '10px',
  //                 }}>
  //                 <div>
  //                   <PDFDownloadLink
  //                     document={<DownloadToPdf data={candidateDetails} />}
  //                     fileName='receipt.pdf'
  //                     style={{
  //                       backgroundColor: '#34A56F',
  //                       color: 'white',
  //                       padding: '15px 20px',
  //                       textDecoration: 'none',
  //                       borderRadius: '5px',
  //                       display: 'inline-block',
  //                       textAlign: 'center',
  //                     }}>
  //                     {({blob, url, loading, error}) =>
  //                       loading ? 'Generating receipt...' : 'Download Receipt'
  //                     }
  //                   </PDFDownloadLink>
  //                 </div>

  //                 <div>
  //                   <ResponsiveFormButton
  //                     label={`${examName} Exam`}
  //                     onClick={() => {
  //                       const newWindow = document.createElement('a');
  //                       newWindow.href =
  //                         'https://screeningtest.examsboard.lagosstate.gov.ng/';
  //                       newWindow.target = '_blank';
  //                       newWindow.rel = 'noopener noreferrer';
  //                       newWindow.click();
  //                     }}
  //                   />
  //                 </div>
  //               </div>
  //             </div>
  //           ),
  //         })
  //       );
  //     }
  //   } catch (error) {
  //     // console.log(error);0
  //   } finally {
  //     setLoadingState((prev) => ({...prev, [billNumber]: false}));
  //   }
  // };
  const generatePin = async (billNumber) => {
    if (loadingState[billNumber]) return;
    
    setLoadingState((prev) => ({ ...prev, [billNumber]: true }));
  
    const bill = billDetails.find((bill) => bill.billNumber === billNumber);
  
    const payersDetails = {
      billNumber: bill.billNumber,
      payerId: bill.payerId,
      assessmentCode: bill.assessmentCode,
      payerInfos: bill.payerInfos,
      schoolId: schoolDetails.schoolId,
      totalPaidFor: bill.quantity,
    };
  
    console.log(payersDetails);
  
    try {
      const res = await axios.post(
        `${API}/innotelligent/generate/school_code/${schoolDetails?.id}`,
        payersDetails,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      console.log(res);
      if (res?.status === 200 || res?.status === 200) {
        const successMessage = res.data.data.message;
        
        setPinDetails(successMessage);
  
        dispatch(
          showModal({
            content: (
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  textAlign: "center",
                  maxWidth: "500px",
                  margin: "0 auto",
                }}
              >
                {/* Success message at the top */}
                <Typography fontWeight="bold" variant="h6">
                  {successMessage}
                </Typography>
  
                {/* Button to proceed */}
                <div style={{ marginTop: "20px" }}>
                  <ResponsiveFormButton
                    label={`${examName} Exam`}
                    onClick={() => {
                      const newWindow = document.createElement("a");
                      newWindow.href =examName === "BECE"
                      ? "https://bece.examsboard.lagosstate.gov.ng/"
                      : "https://placementtest.examsboard.lagosstate.gov.ng/";
                      newWindow.target = "_blank";
                      newWindow.rel = "noopener noreferrer";
                      newWindow.click();
                    }}
                  />
                </div>
              </div>
            ),
          })
        );
      }else if (res?.data?.status === "failed") {
              Swal.fire({
                title: "Error",
                text: res?.data?.data?.message,
                icon: "error",
                confirmButtonText: "Ok",
              });
            }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong!",
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      setLoadingState((prev) => ({ ...prev, [billNumber]: false }));
    }
  };
  
  













  // const generateManualPin = async (billNumber) => {
  //   // Find the specific bill with the matching payerId
  //   setLoadingState((prev) => ({...prev, [billNumber]: true}));
  //   const bill = billDetails.find((bill) => bill.billNumber === billNumber);

  //   const payersManualDetails = {
  //     billNumber: bill.billNumber,
  //     payerId: bill.payerId,
  //     assessmentCode: bill.assessmentCode,
  //     payerInfos: bill.payerInfos,
  //   };

  //   //  console.log(payersDetails)
  //   try {
  //     // setLoading(true)
  //     const res = await axios.post(
  //       `${API}/innotelligent/generate/school_code/${schoolDetails?.id}`,
  //       payersManualDetails,
  //       {
  //         headers: {Authorization: `Bearer ${token}`},
  //       }
  //     );

  //     console.log(res);
  //     if (res?.status === 200 || res?.status === 200) {
  //       // console.log(res?.status)
  //       // const { fullName, examinationNumber, pin } = res.data.data.candidateLoginDetails[0];
  //       const candidateDetails = res.data.data;

  //       // Generate candidate details content
  //       const candidateContent = candidateDetails.map((candidate, index) => (
  //         <div key={index} style={{width: '100%'}}>
  //           <div
  //             style={{
  //               display: 'flex',
  //               height: 'auto',
  //               gap: window.innerWidth >= 500 ? '90px' : '40px',
  //             }}>
  //             <Typography>{candidate.examCode}</Typography>
  //             {/* <Typography>{candidate.examinationNumber}</Typography>
  //             <Typography>{candidate.pin}</Typography> */}
  //           </div>
  //         </div>
  //       ));
  //       console.log(candidateDetails);
  //       // console.log(payersDetails)
  //       setPinDetails(payersManualDetails);

  //       dispatch(
  //         showModal({
  //           content: (
  //             <div>
  //               <div>
  //                 <div
  //                   id='modalContent'
  //                   style={{
  //                     backgroundColor: 'white',
  //                     display: 'flex',
  //                     flexDirection: 'column',
  //                     alignItems: 'center',
  //                     height: '550px',
  //                     maxHeight: '400px',
  //                     overflowY: 'auto',
  //                     overflowX: 'auto',
  //                     position: 'relative',
  //                   }}>
  //                   <Typography fontWeight={'bold'} variant='h6'>
  //                     Receipt generated successfully
  //                   </Typography>
  //                   {/* the background image */}
  //                   <div className={styles.receipt_image}></div>
  //                   <div
  //                     style={{
  //                       display: 'flex',
  //                       gap: window.innerWidth >= 500 ? '90px' : '40px',
  //                       marginTop: '20px',
  //                     }}>
  //                     <Typography fontWeight={'bold'}>Full Name:</Typography>
  //                     <Typography fontWeight={'bold'}>
  //                       Examination Number:
  //                     </Typography>
  //                     <Typography fontWeight={'bold'}>Pin:</Typography>
  //                   </div>
  //                   <div style={{gap: '10px'}}>{candidateContent}</div>
  //                 </div>
  //               </div>
  //               <div
  //                 style={{
  //                   display: 'flex',
  //                   flexWrap: 'wrap',
  //                   alignItems: 'center',
  //                   justifyContent: 'center',
  //                   margin: 'auto',
  //                   gap: window.innerWidth >= 500 ? '100px' : '10px',
  //                 }}>
  //                 <div>
  //                   <PDFDownloadLink
  //                     document={<DownloadToPdf data={candidateDetails} />}
  //                     fileName='receipt.pdf'
  //                     style={{
  //                       backgroundColor: '#34A56F',
  //                       color: 'white',
  //                       padding: '15px 20px',
  //                       textDecoration: 'none',
  //                       borderRadius: '5px',
  //                       display: 'inline-block',
  //                       textAlign: 'center',
  //                     }}>
  //                     {({blob, url, loading, error}) =>
  //                       loading ? 'Generating receipt...' : 'Download Receipt'
  //                     }
  //                   </PDFDownloadLink>
  //                 </div>

  //                 <div>
  //                   <ResponsiveFormButton
  //                     label={`${examName} Exam`}
  //                     onClick={() => {
  //                       const newWindow = document.createElement('a');
  //                       newWindow.href =
  //                         'https://screeningtest.examsboard.lagosstate.gov.ng/';
  //                       newWindow.target = '_blank';
  //                       newWindow.rel = 'noopener noreferrer';
  //                       newWindow.click();
  //                     }}
  //                   />
  //                 </div>
  //               </div>
  //             </div>
  //           ),
  //         })
  //       );
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //   } finally {
  //     setLoadingState((prev) => ({...prev, [billNumber]: false}));
  //   }
  // };
  //     console.log(res);
  //     if (res?.status === 200) {
  //       // Dispatch the modal with the content "Hello World"
  //       dispatch(showModal({
  //         content: (
  //           <div>
  //             Hello World
  //           </div>
  //         ),
  //       }));
  //     }
  //     // console.log("Posted Bill:", payersDetails);
  //     // console.log("Response Data:", res.data); // Log the response data
  //     // toast.success(`Bill ${bill.billNumber} status checked successfully`);
  //   } catch (error) {
  //     console.error(`Error posting Bill ${bill.billNumber}:`, error.response ? error.response.data : error.message);
  //     toast.error(`Bill ${bill.billNumber} not found`);
  //   } finally {
  //     setLoading(false)
  //   }
  // };

  // const receiptDownload = async () => {
  //   setLoadingDownload(true);
  //   try {
  //     const modalReceipt = document.getElementById('modalContent');
  //     const imageUrl = await domtoimage.toJpeg(modalReceipt, {cacheBust: true});
  //     const downloadLink = document.createElement('a');
  //     downloadLink.href = imageUrl;
  //     downloadLink.download = 'Receipt Generated.jpg';
  //     document.body.appendChild(downloadLink);
  //     downloadLink.click();
  //     document.body.removeChild(downloadLink);
  //   } catch (error) {
  //     console.error('Download failed:', error);
  //   } finally {
  //     setLoadingDownload(false);
  //   }
  // };

  // console.log(receiptDownload)

  //  not using this for now

  useEffect(() => {
    // console.log(token);
    getAllBills();
    // console.log(details.billNumber)
    //N-8592972
  }, []);

  return (
    <div>
      {billDetails ? (
        billDetails?.length === 0 ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '50px',
              gap: '40px',
            }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '5px',
              }}>
              <MdErrorOutline size={'25px'} />
              <Typography align='center' fontSize={'19px'} fontWeight={500}>
                {' '}
                You have not raised a bill/invoice on this platform yet.{' '}
              </Typography>
            </div>

            <Typography align='center' fontSize={'17px'} fontWeight={600}>
              {' '}
              Click on the User Details tab to generate an invoice.{' '}
            </Typography>
          </div>
        ) : (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            {billDetails?.map((item, i) => (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: window.innerWidth >= 320 ? '30px 0px' : '30px',
                  width: window.innerWidth >= 320 ? '400px' : '150px',
                }}>
                <div
                  style={{
                    border: '1px solid #34A56F',
                    borderRadius: '10px',
                    width: window.innerWidth >= 720 ? '650%' : '80%',
                    height: window.innerWidth >= 500 ? '450px' : '570px',
                    display: 'flex',
                    flexDirection: 'column',
                    padding:
                      window.innerWidth >= 320
                        ? '20px 20px 20px 20px'
                        : '200px, 200px',
                    gap: '25px',
                    backgroundColor: '#f2fcf8',
                  }}>
                  <div
                    // id="modalContent"
                    style={{
                      backgroundColor: '#f2fcf8',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '20px',
                      padding: '20px',
                    }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Bill Number: {item?.billNumber}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                        textTransform: 'capitalize',
                      }}>
                      Payer Name: {item?.customerName}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Amount Paid: {item?.amountGenerated}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      No of Candidates: {item?.quantity}
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Time: {formatDate(item?.createdAt).time}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '18px',
                        fontWeight: '600',
                      }}>
                      Date: {formatDate(item?.createdAt).date}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                      }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          fontSize: '18px',
                          fontWeight: '600',
                          gap: '10px',
                        }}>
                        Payment Status:{' '}
                      </div>
                      {item.status === 'Awaiting Confirmation' ? (
                        <p
                          style={{
                            padding: '5px 5px',
                            backgroundColor: '#EE9513',
                            fontSize: '17px',
                            color: '#ffffff',
                            borderRadius: '4px',
                          }}>
                          {'Pending'}
                        </p>
                      ) : item.status === 'Paid' || item.status === 'paid' ? (
                        <p
                          style={{
                            padding: '5px 5px',
                            backgroundColor: '#34a56f',
                            fontSize: '17px',
                            color: '#ffffff',
                            borderRadius: '4px',
                          }}>
                          {item.status.charAt(0).toUpperCase() +
                            item.status.slice(1)}
                        </p>
                      ) : (
                        <p
                          style={{
                            padding: '5px 5px',
                            backgroundColor: '#34a56f',
                            fontSize: '17px',
                            color: '#ffffff',
                            borderRadius: '4px',
                          }}>
                          {'Pending'}
                        </p>
                      )}
                    </div>
                  </div>


                  <div
                    style={{
                      display: 'flex',
                      flexWrap: window.innerWidth <= 500 ? 'wrap' : '',
                      justifyContent: 'center',
                      alignItems: 'center',
                      margin: 'auto',
                      gap: window.innerWidth >= 500 ? '30px' : '10px',
                    }}>
                    <div>
                      <ResponsiveFormButton
                        type='button'
                        // width="small"
                        label='Download Invoice'
                        onClick={() => {
                          window.scrollTo(5, 50);
                          navigate(`/invoice/download/${item.id}`);
                        }}
                      />
                    </div>
                    <div>
                      {item?.status === 'Paid' ? (
                        <ResponsiveFormButton
                          type='button'
                          disabled={loadingState[item.billNumber] || false}
                          // width="small"
                          // label={loading ? <Spinner width="5%"/> : "Generate Receipt"}
                          label={
                            loadingState[item.billNumber] ? (
                              <Spinner width='5%' />
                            ) : (
                              'Log Payment'
                            )
                          }
                          onClick={() => generatePin(item.billNumber)}
                        />
                      ) : item?.status === 'paid' ? (
                        // Manual Generation
        <ResponsiveFormButton
                          type='button'
                          disabled={loadingState[item.billNumber] || false}
                          // width="small"
                          // label={loading ? <Spinner width="5%"/> : "Generate Receipt"}
                          label={
                            loadingState[item.billNumber] ? (
                              <Spinner width='5%' />
                            ) : (
                              'Log Payment'
                            )
                          }
                          onClick={() => generatePin(item.billNumber)}
                        /> 
                      ) : (
                        <ResponsiveFormButton
                        type='button'
                        disabled={loadingState[item.billNumber] || false}
                        // width="small"
                        // label={loading ? <Spinner width="5%"/> : "Generate Receipt"}
                        label={
                          loadingState[item.billNumber] ? (
                            <Spinner width='5%' />
                          ) : (
                            'Log Payment'
                          )
                        }
                        onClick={() => generatePin(item.billNumber)}
                      />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Box>
        )
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '50px',
            gap: '5px',
          }}>
          <TbFaceIdError size={'25px'} />
          <Typography align='center' fontSize={'19px'} fontWeight={500}>
            {' '}
            Can't seem to get your bill/invoice details at the moment. Can you
            try again later?{' '}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default SchoolBaseBillCard;
